import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';

export function IsDispatched(x: SmartSendItemApiModel) {
  return x.MarketplaceStatus === 'Dispatched';
}
